<template>
  <section>
    <m-table-list
      ref="tableList"
      :fetch-list-func="fetchListFunc"
      :search-form.sync="filters"
    >
      <!-- 筛选条件 -->
      <template v-slot:search-items>
        <m-search-panel
          @searchBoxChange="handleSearch"
          isShowOpenButton
          @keyup.enter.native="handleSearch()"
        >
          <div slot="title">
            数据筛选
            <el-input
              style="padding-left: 20px; width: 310px !important"
              maxlength="50"
              placeholder="输入问题标题/问题描述搜索"
              clearable
              size="medium"
              v-model.trim="filters.keyword"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="handleSearch"
              ></el-button>
            </el-input>
          </div>
          <div class="filters">
            <div class="query-item-all">
              <div class="filter-item">
                <div class="demonstration">工单编号</div>
                <el-input
                  v-model="filters.wkOrderId"
                  placeholder="编号"
                  oninput="value=value.replace(/[^\d]/g,'')"
                ></el-input>
              </div>
              <div class="filter-item">
                <div class="demonstration">节点名称</div>
                <el-input
                  v-model.trim="filters.taskName"
                  placeholder="节点名称"
                ></el-input>
              </div>
              <div class="filter-item">
                <div class="demonstration">审批状态</div>
                <el-select
                  v-model="filters.approveStatus"
                  placeholder="审批状态"
                >
                  <el-option
                    v-for="(item, index) in approveStatusOptions"
                    :key="index"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
              </div>
              <div class="filter-item">
                <div class="demonstration">工单分类</div>
                <el-select
                  v-model="filters.parentQaTypeId"
                  placeholder="工单分类"
                  @change="workCutChange($event)"
                  filterable
                >
                  <el-option
                    v-for="(item, index) in workCutList"
                    :key="index"
                    :value="item.parentTypeId"
                    :label="item.parentQaTypeName"
                  ></el-option>
                </el-select>
              </div>
              <div class="filter-item">
                <div class="demonstration">工单类型</div>
                <el-select
                  :disabled="!filters.parentQaTypeId"
                  v-model="filters.qaTypeId"
                  placeholder="工单类型"
                  filterable
                >
                  <el-option
                    v-for="(item, index) in workTypeList"
                    :key="index"
                    :value="item.qaTypeId"
                    :label="item.qaTypeName"
                  ></el-option>
                </el-select>
              </div>
              <div class="filter-item">
                <div class="demonstration">优先级</div>
                <el-select v-model="filters.priority" placeholder="优先级">
                  <el-option
                    v-for="(label, value) in priorityEnum"
                    :key="label"
                    :value="value"
                    :label="label"
                  ></el-option>
                </el-select>
              </div>
              <div class="filter-item">
                <div class="demonstration">提交人姓名</div>
                <el-input
                  v-model.trim="filters.authorName"
                  placeholder="提交人姓名"
                ></el-input>
              </div>
              <div class="filter-item">
                <div class="demonstration">承接人姓名</div>
                <el-input
                  v-model.trim="filters.acceptorName"
                  placeholder="承接人姓名"
                ></el-input>
              </div>
              <div class="filter-item">
                <div class="demonstration">提交时间</div>
                <div class="block">
                  <el-date-picker
                    style="z-index: 0"
                    v-model="submitTime"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @change="handleSubmitTimeChange"
                    value-format="timestamp"
                  >
                  </el-date-picker>
                </div>
              </div>
              <!-- 查询 -->
              <div class="filter-item buttons button">
                <el-button
                  type="primary"
                  size="small"
                  class="find"
                  @click="handleSearch"
                  >查询
                </el-button>
                <el-button
                  type="primary"
                  size="small"
                  plain
                  class="reset"
                  @click="handleClearSearchForm"
                  >重置
                </el-button>
              </div>
            </div>
          </div>
        </m-search-panel>
      </template>

      <template v-slot:page-title>
        <div class="page-tabe-title">
          <div class="right">
            <span class="line"></span>
            <div>数据列表</div>
          </div>
        </div>
      </template>

      <!-- 表格 -->
      <template v-slot:table-columns>
        <el-table-column
          prop="wkOrderId"
          label="工单编号"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          label="问题标题"
          prop="wkOrderTopic"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="工单类型"
          prop="qaTypeName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="节点名称" prop="taskName" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          label="创建时间"
          prop="creatTime"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          label="审批状态"
          prop="approveStatus"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-tag
              size="mini"
              :type="approveStatusEnum[scope.row.approveStatus].type"
            >
              {{ approveStatusEnum[scope.row.approveStatus].label }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          label="审批时间"
          prop="approveTime"
          show-overflow-tooltip
        >
          <template slot-scope="scope">{{
            scope.row.approveTime || "-"
          }}</template>
        </el-table-column>
        <el-table-column
          label="提交时间"
          prop="submitTime"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          label="优先级"
          prop="priority"
          :formatter="formatPriority"
        ></el-table-column>
        <el-table-column label="操作" width="170px">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              @click="look(row.id, row.wkOrderId, row.taskId)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </template>
    </m-table-list>
  </section>
</template>

<script>
import tableList from "components/tableList";
import api from "plus/api";
import {
  approveStatusEnum,
  approveStatusOptions,
  priorityEnum,
} from "@/components/data.js";

export default {
  name: "work.myApprove.list",
  data() {
    return {
      filters: {},
      workTypeList: [],
      workCutList: [],
      submitTime: [],
      approveStatusEnum,
      approveStatusOptions,
      priorityEnum,
    };
  },
  components: {
    "m-table-list": tableList,
  },
  activated() {
    this.getDropDownList();
  },
  methods: {
    fetchListFunc: api.work.getMyApproveWork,
    formatPriority(row) {
      return this.priorityEnum[row.priority];
    },
    handleSearch() {
      this.$refs.tableList.handleSearch();
    },
    handleClearSearchForm() {
      this.$refs.tableList.resetSearchForm();
      this.submitTime = [];
    },
    look(id, wkOrderId, taskId) {
      this.$router.push({
        name: "work.myApprove.detail",
        query: { id, wkOrderId, taskId },
      });
    },
    // 分类改变引起类型改变
    workCutChange(e) {
      this.filters.qaTypeId = "";
      let filters = {
        id: e,
      };
      api.dropDownList.getWorkType(filters).then((res) => {
        this.workTypeList = res.data.data;
      });
    },
    getDropDownList() {
      api.dropDownList.getWorkCut().then((res) => {
        this.workCutList = res.data.data;
      });
    },
    // 时间筛选
    handleSubmitTimeChange(val) {
      if (val) {
        this.filters.submitBeginTime =
          this.formatTimestamp(val[0]) + " 00:00:00";
        this.filters.submitEndTime = this.formatTimestamp(val[1]) + " 23:59:59";
      } else {
        this.filters.submitBeginTime = "";
        this.filters.submitEndTime = "";
        this.submitTime = [];
      }
    },
    formatTimestamp(timestamp) {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从0开始
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },
  },
};
</script>
